export default __webpack_public_path__ + "static/fiser-fe3284db1c6324bfc7462bc34ac5add8.png";